// frontend/src/pages/settings/users-roles/index.tsx
import { useCallback, useEffect, useState } from 'react';
import { rbacApi } from './api';
import { RolesTab } from './RolesTab';
import { PendingTab } from './PendingTab';
import { UsersTab } from './UsersTab';
import { useCan, visibleTabs, pickActiveTab, NoAccess } from '../../../lib/rbac';

type Tab = 'users' | 'roles' | 'pending';

export function UsersRolesPage() {
  const can = useCan();
  const [tab, setTab] = useState<Tab>('roles');
  const [pendingCount, setPendingCount] = useState(0);
  const refreshCount = useCallback(async () => {
    const res = await rbacApi.pendingCount();
    if (res.success && res.data) setPendingCount(res.data.count);
  }, []);
  useEffect(() => { refreshCount(); }, [refreshCount]);

  const tabs: { key: Tab; label: string }[] = [
    { key: 'users', label: 'Usuarios' },
    { key: 'roles', label: 'Roles' },
    { key: 'pending', label: 'Pendientes' },
  ];
  // Las tres pestañas se abren con la misma llave: o están todas o no está la pantalla.
  const allowedTabs = visibleTabs('usersRoles', tabs, can);
  const active = (pickActiveTab('usersRoles', tabs, tab, can) ?? tab) as Tab;
  if (allowedTabs.length === 0) return <NoAccess />;

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-[var(--color-text)]">Usuarios y Roles</h2>
      {pendingCount > 0 && (
        <div className="px-3 py-2 rounded-lg text-xs bg-amber-500/10 border border-amber-500/30 text-amber-700">
          Hay {pendingCount} permiso{pendingCount === 1 ? '' : 's'} nuevo{pendingCount === 1 ? '' : 's'} sin decidir.{' '}
          <button className="underline" onClick={() => setTab('pending')}>Ver pendientes</button>
        </div>
      )}
      <div className="flex gap-1 border-b border-[var(--color-border)]">
        {allowedTabs.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            className={`px-3 py-2 text-sm -mb-px border-b-2 ${active === t.key ? 'border-[var(--color-primary)] text-[var(--color-primary)] font-medium' : 'border-transparent text-[var(--color-text-secondary)]'}`}
          >
            {t.label}{t.key === 'pending' && pendingCount > 0 ? ` (${pendingCount})` : ''}
          </button>
        ))}
      </div>
      {active === 'users' && <UsersTab />}
      {active === 'roles' && <RolesTab />}
      {active === 'pending' && <PendingTab onChanged={refreshCount} />}
    </div>
  );
}
